import React from "react";

const About = () => {
  return (
    <>
      <div className="about">
        About the global dialysis or dialysis in general
      </div>
    </>
  );
};

export default About;
